// LANGUAGE --- CATEGORY / TYPE --- SLUG

exports.linkResolver = (doc) => {
  const defaultLanguage = "el-GR";
  if (doc?.internal?.type) {
    switch (doc?.internal?.type) {
      case "STRAPI_HOMEPAGE": {
        return doc?.locale === defaultLanguage
          ? `/`
          : `/${doc?.locale?.split("-")[0]}`;
      }
      case "STRAPI_PAGE": {
        if (doc?.category?.slug) {
          return doc?.locale === defaultLanguage
            ? `/${doc?.category.slug}/${doc?.slug}`
            : `/${doc?.locale?.split("-")[0]}/${doc?.category.slug}/${
                doc?.slug
              }`;
        } else {
          return doc?.locale === defaultLanguage
            ? `/${doc?.slug}`
            : `/${doc?.locale?.split("-")[0]}/${doc?.slug}`;
        }
      }
      default: {
        return doc?.locale === defaultLanguage
          ? `/${doc?.slug}`
          : `/${doc?.slug}`;
      }
    }
  } else {
    if (doc?.category?.slug || doc?.category?.data?.attributes?.slug) {
      return doc?.locale === defaultLanguage
        ? `/${doc?.category.data.attributes.slug || doc?.category.slug}/${
            doc?.slug
          }`
        : `/${doc?.locale?.split("-")[0]}/${
            doc?.category.data.attributes.slug || doc?.category.slug
          }/${doc?.slug}`;
    } else {
      return doc?.locale === defaultLanguage
        ? `${doc?.slug ? `/${doc?.slug}` : "/"}`
        : `${doc?.slug ? `/${doc?.slug}` : "/"}`;
    }
  }
};
